import {Component, OnInit} from '@angular/core';
import {Login} from './login';
import {connectApi} from '../common/connect-api';
import {SESSION_STORAGE_KEYS} from '../common/session-storage-keys';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {AcceptTermsConditionsService} from '../common/accept-terms-conditions.service';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AllValidationErrors, getFormValidationErrors} from "../common/get-form-validation-errors";
import {Messages} from '../shared/messages';
import {NotificationService} from '../common/notification/notification.service';
import {CirfService} from "../cirf/cirf.service";
import {UserAuthenticationService} from "../common/user-authentication.service";
import {User} from "../common/user";
import {ConnectDialog} from "../common/confirm-dialog/connect-dialog";
import {ConfirmDialogService} from "../common/confirm-dialog/confirm-dialog.service";
import {SystemConfigurationService} from "../common/configuration/system-configuration.service";
import {CirfConfigService} from "../cirf/config/cirf-config-service";

@Component({
    selector: 'dp-connect-login',
    templateUrl: './login.component.html',
    animations: [
        trigger('visibilityChanged', [
            state('shown', style({opacity: 1})),
            state('hidden', style({opacity: 0})),
            transition('shown => hidden', animate('300ms')),
            transition('hidden => shown', animate('900ms')),
        ])
    ]
})
export class LoginComponent implements OnInit {


    routerState: any;
    nextState: any;
    connectToken: string;
    isLoginIdReadOnly: boolean = false;
    formGroup: FormGroup;
    loginId: string;
    isCurrentPasswordVisible: boolean;

    constructor(private httpClient: HttpClient,
                private  router: Router,
                private cirfService: CirfService,
                public route: ActivatedRoute,
                private acceptTermsConditionsService: AcceptTermsConditionsService,
                private notificationService: NotificationService,
                public userAuthenticationService: UserAuthenticationService,
                private systemConfigurationService: SystemConfigurationService,
                public confirmDialogService: ConfirmDialogService,
                private cirfConfigService: CirfConfigService) {
        this.routerState = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras ? this.router.getCurrentNavigation().extras.state : undefined;
    }


    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            let connectToken = params['ct'];
            if (connectToken) {
                this.router.navigate(['./activate/' + connectToken]);
            }

            let resetToken = params['rp'];
            if (resetToken) {
                this.router.navigate(['./reset-password/' + resetToken]);

            }

            let verificationToken = params['vt'];
            if (verificationToken) {
                this.validateTokenAndLogin(verificationToken)
            }
            const sessionTimeOut = params['sto'];
            if (sessionTimeOut) {
                if (sessionTimeOut === '1') {
                    this.notificationService.showNotification(Messages.loginSessionExpired, 'error');
                }
                if (sessionTimeOut === '2') {
                    this.notificationService.showNotification(Messages.loginSessionTimedOut, 'error');
                }
            }
        });

        sessionStorage.clear();
        this.cirfService.resetCirf();
        this.cirfConfigService.clearMatterCirfConfigCache();
        if (this.routerState) {
            this.loginId = this.routerState.loginId;
            this.nextState = this.routerState.nextState;
            this.isLoginIdReadOnly = true;
            this.connectToken = this.routerState.connectToken;
        }
        this.formGroup = new FormGroup({
            'loginId': new FormControl({value: this.loginId, disabled: !!this.loginId}, Validators.required),
            'password': new FormControl('', Validators.required),
            'rememberMe': new FormControl(),
        })
    }


    signIn(): void {
        let errors: AllValidationErrors[] = getFormValidationErrors(this.formGroup.controls);
        if (errors.length == 0) {
            let login = new Login()
            login.loginId = this.formGroup.controls['loginId'].value;
            login.password = this.formGroup.controls['password'].value;
            login.rememberMe = this.formGroup.controls['rememberMe'].value;
            this.httpClient.post<any>(connectApi.login, login)
                .subscribe(response => {
                    if (response && response['User']) {
                        let user = new User(response['User']);
                        this.processLogin(user);
                    }

                },
                    (error) => {
                    if (error?.error?.Error?.errorCode === 'app.accountLockedOut') {
                        this.showAccountLockedDialog();
                    }
                });
        }
    }

    processLogin(user: User): void {
        if (user) {
            this.userAuthenticationService.setUpUserSession(user);
            if(this.connectToken){
                sessionStorage.setItem(SESSION_STORAGE_KEYS.connectToken, this.connectToken);
            }

            if(user.passwordChangeRequired){
                if(this.nextState){
                    this.router.navigate(['./setup-password'], {state: {nextState: this.nextState}});
                } else {
                    this.router.navigate(['./setup-password']);
                }

            } else {
                //Load system configuration
                this.systemConfigurationService.loadSystemConfiguration();
                this.navigateToStep(user);
            }

        }
    }

    navigateToStep(user: User) : void {
        const userTermsAcceptedDate = user.termsAcceptedDate;
        this.acceptTermsConditionsService.getTermsAndConditions().subscribe(
            (res) => {
                if (userTermsAcceptedDate < res.createdDate) {
                    if (this.nextState) {
                        this.router.navigate(['./accept-terms-conditions/'], {state: {nextState: this.nextState}});
                    } else {
                        this.router.navigate(['./accept-terms-conditions']);
                    }
                } else {
                    if (this.nextState) {
                        this.router.navigate(['./home/matter-summary-home'],{state: {nextState: this.nextState}});
                    } else {
                        this.router.navigate(['./home'] );
                    }
                }
            });
    }


    validateTokenAndLogin(token: any) {
        if (token) {
            this.userAuthenticationService.getUserByToken(token).subscribe(
                (response) => {
                    if (response) {
                        let user = new User(response);
                        this.processLogin(user);
                    }
                });
        }
    }

    showAccountLockedDialog() {
        let connectDialog: ConnectDialog = new ConnectDialog();
        connectDialog.message = 'Your account is locked. Proceed with password reset?';
        connectDialog.dialogType = 'ERROR';
        this.confirmDialogService.confirmDialog(connectDialog).subscribe(
            res => {
                if (res) {
                    this.router.navigate(['./forgot-password/'], {state: {loginId: this.formGroup.controls['loginId'].value, resetPassword: true}});
                }
            }
        );

    }
}
